export default __webpack_public_path__ + "static/media/a17.59168a73.jpg";